import { appUtils } from "../../../../utils/app.utils";

const isValidCardPan = value => {
  let valid = false;
  if (
    value &&
    appUtils.luhnCheck(value) &&
    value.length >= 16 &&
    value.length <= 24
  ) {
    valid = true;
  }
  return valid;
};

export const validateCardStatementSearch = values => {
  const errors = {};
  if (!values.cardPan) {
    errors.cardPan = "Please enter a card PAN";
  } else if (values.cardPan && !isValidCardPan(values.cardPan)) {
    errors.cardPan = "Please enter a valid Card PAN";
  }
  if (!values.startDate) {
    errors.startDate = "Please enter a start date";
  }
  if (!values.endDate) {
    errors.endDate = "Please enter an end date";
  }
  if (!values.expiryDate) {
    errors.expiryDate = "Please enter card expiry date";
  }
  if (!values.issuerNumber) {
    errors.issuerNumber = "Please enter card issuer number";
  }
  if (!values.sequenceNumber) {
    errors.sequenceNumber = "Please enter card sequence number";
  }
  return errors;
};